(ns frontend.view.modals.decisions.sub
  (:require
   [re-frame.core :as rf]
   [frontend.state.current-session :as session]))

(def create-modal :create-modal)
(def editor-modal :editor-modal)

(rf/reg-sub
 ::delete-confirmation-modal?
 (fn [db _]
   (get db ::delete-confirmation-modal?)))

(rf/reg-sub
 ::modal-type
 (fn [db _]
   (get db ::modal-type)))

(rf/reg-sub
 ::entity-type
 (fn [db _]
   (get db ::entity-type)))

(rf/reg-sub
 ::modified?
 (fn [db _]
   (let [temp-entities (::entities db)
         temp-entity-ids (keys temp-entities)
         id->original-entity
         (->> temp-entity-ids
              (keep (fn [entity-id]
                      (when-let [entity (session/get-entity entity-id)]
                        [entity-id entity])))
              (into {}))
         entities-modified?
         (->> temp-entity-ids
              (filter (fn [entity-id]
                        (let [entity (get temp-entities entity-id)
                              original (get id->original-entity entity-id)]
                          (not= entity original))))
              (count)
              (< 0))

         disabled-entities?
         (->> db
              ::disabled-entity-ids
              (count)
              (< 0))

         added-entities?
         (->> db
              ::added-entity-ids
              (count)
              (< 0))]
     (or entities-modified?
         added-entities?
         disabled-entities?))))


(rf/reg-sub
 ::decision-id
 (fn [db _]
   (get db ::decision-id)))

(rf/reg-sub
 ::entities
 (fn [db _]
   (get db ::entities)))

(rf/reg-sub
 ::validation-errors
 (fn [db _]
   (get db ::validation-errors)))

(rf/reg-sub
 ::focused-condition-id
 (fn [db]
   (get db ::focused-condition-id)))
